interface EndSessionConfirmProps {
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Ending always asks first.
 *
 * The order lives in memory on the server for the life of this connection, so a
 * stray tap on a page someone has been talking to for three minutes must not be
 * able to throw it away silently.
 *
 * Rendered as a sibling of the page stack, never inside a spacing container —
 * `space-y-*` sets margin-top on every child after the first, which on a
 * `fixed inset-0` backdrop shifts the overlay down and leaves an undimmed strip
 * across the top. That bug has shipped more than once in this repo.
 */
export function EndSessionConfirm({ onConfirm, onCancel }: EndSessionConfirmProps): JSX.Element {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-6">
      <div className="w-full max-w-xs rounded-2xl bg-[#17171f] p-6 text-center">
        <h2 className="text-[16px] font-semibold text-white">Finish ordering?</h2>
        <p className="mt-2 text-[13px] leading-relaxed text-white/50">
          This ends the conversation and sends your order to the kitchen.
        </p>
        <div className="mt-5 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 rounded-full border border-white/20 py-2.5 text-[14px] text-white/80"
          >
            Keep talking
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 rounded-full bg-brand-green py-2.5 text-[14px] font-semibold text-black"
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  )
}
